@if (isLoading() > 0) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
}

<header class="flex header">
  <h2>
    {{ labDip()?.labDipNumber ? ('LabDipDetails_Title' | translateWF: 'Edit Lab Dip') : ('LabDipDetails_Title' | translateWF: 'Create Lab Dip') }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <form [formGroup]="mainForm" class="w-full space-y-4">
    <div class="span-12-4">
      <div class="form-box-row justify-between mb-2">
        <span class="font-medium">{{ 'LabDip' | translateWF: 'Lab Dip' }}</span>
        <span class="text-gray-600">
          {{ labDip()?.labDipNumber }}
        </span>
      </div>

      <div class="form-box-row justify-between mb-4">
        <span class="font-medium">{{ 'LabDips_Request' | translateWF: 'Lab Dip Request' }}</span>
        <span class="text-gray-600">
          {{ labDip()?.labDipRequestNumber }}
        </span>
      </div>
    </div>

    <div class="row-between-center mb-2">
      <h4>{{ 'LabDips_Approved_Lab_Dip' | translateWF: 'Approved Lab Dip' }}</h4>
      @if (existingRecipe()) {
        <span class="text-sm text-blue-600 font-medium"> {{ 'LabDips_ExistingRecipe' | translateWF: 'Existing Recipe' }}: {{ existingRecipe()?.recipeNumber }} </span>
      }
    </div>

    <div class="grid-6">
      <div class="span-4">
        <div class="form-box">
          <label>{{ 'LabDip' | translateWF: 'Lab Dip Number' }}</label>
          <input type="text" pInputText class="w-full" [value]="labDip()?.labDipNumber" disabled />
        </div>
      </div>

      <div class="span-2">
        <div class="form-box">
          <label>{{ 'LabDips_RecipeCharacter' | translateWF: 'Recipe Character' }}</label>
          <input type="text" pInputText class="w-full" formControlName="recipeCharacter" />
        </div>
      </div>
    </div>

    <!-- Add Shade Type Dropdown -->
    <div class="grid-1 mt-4">
      <div class="form-box">
        <label for="shadeType" class="required">{{ 'LabDips_ShadeType' | translateWF: 'Shade' }}</label>

        <p-select appendTo="body" class="w-full" [options]="shadeOptions" formControlName="shadeReference" />
      </div>
    </div>

    <div class="span-12-4">
      <div class="form-box-row justify-between mb-2">
        <span class="font-medium">{{ 'Fabric' | translateWF: 'Fabric' }}</span>
        <span class="text-gray-600">
          <!-- @for (item of labDip()?.labDipRequest; track item.id) {
            @for (fabric of item?.fabrics; track fabric.id) {
              <span class="mr-2"
                >{{ fabric.fabricCode }} - {{ fabric.longDescription }}</span
              >
            }
          } -->
        </span>
      </div>

      @for (fabric of fabrics; track fabric.id) {
        <div class="form-box-row justify-between mb-2">
          <span class="font-medium">{{ fabric.fabricCode }}</span>
          <span class="text-gray-600">{{ fabric.longDescription }}</span>
        </div>
      }

      <h2>Yarns</h2>

      @for (yarn of yarns; track yarn.id) {
        <div class="form-box-row justify-between mb-2">
          <span class="font-medium">{{ yarn.code }}</span>
          <span class="text-gray-600">{{ yarn.longDescription }}</span>
        </div>
      }

      <!-- <div class="form-box-row justify-between mb-4">
        <span class="font-medium">
          {{ 'LabDipDetails_Composition' | translateWF: 'Yarn Composition' }}
        </span>
        @for (item of labDip()?.labDipRequest; track item.id) {
          @for (fabric of item?.fabrics; track fabric.id) {
            @for (
              greige of fabric?.greige?.yarnDetails;
              track greige.yarnCode
            ) {
              <span class="text-gray-600 mr-2">
                {{ greige.yarnCode }}
              </span>
            }
          }
        }
      </div> -->
    </div>
  </form>
</section>

<footer>
  <p-button class="w-full" [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
  @if (canEdit) {
    <p-button type="submit" class="w-full" [label]="'Common_Save' | translateWF: 'Save'" (click)="onSave()" [disabled]="!canSave()" />
  }
</footer>
